import React from 'react'
import PropTypes from 'prop-types'
import * as S from './style'

const SeeOffer = ({ link }) => {
  return (
    <S.SeeOfferContainer id="verOferta">
      <S.SeeOfferLink
        href={`${link}`}
        id="link_card"
        target="_blank"
      >
        Ver Oferta
      </S.SeeOfferLink>
    </S.SeeOfferContainer>
  )
}

SeeOffer.propTypes = {
  link: PropTypes.string.isRequired,
}

export default SeeOffer
